<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('/admin/medical_cancer')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">Edit Medical Cancer</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <p>Title</p>
        <base-input
          alternative
          class="mb-3"
          name="Title"
          :rules="{ required: true }"
          placeholder="Title"
          v-model="title"
        >
        </base-input>

        <p>Location</p>
        <b-form-select
          v-model="Location"
          :options="options"
          :rules="{ required: true }"
        ></b-form-select>

        <p>Category</p>
        <b-form-select
          v-model="Category"
          :options="Categoryoptions"
          :rules="{ required: true }"
        ></b-form-select>

        <p>Description</p>
        <base-input
          alternative
          class="mb-3"
          name="Description"
          placeholder="Description"
          v-model="Description"
          :rules="{ required: true }"
        >
        </base-input>

        <FileUploader :image="image" :onSuccess="handleSuccess" />
        <img :src="image" alt="" v-if="image" />
        <div class="flex cursor-pointer items-center my-2" v-if="image">
          <base-button type="danger" class="px-8" @click="handleRemove">
            Remove image
          </base-button>
        </div>

        <div class="py-4 customboxed">
          <p>Redirect Link</p>
          <base-input
            class="mb-3"
            name="Link"
            placeholder="Add your Page link"
            v-model="link"
            :rules="{ required: true }"
          >
          </base-input>
        </div>
        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Update</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";

// import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

import { mapState } from "vuex";
import "vue-advanced-cropper/dist/style.css";
import { Cropper } from "vue-advanced-cropper";
// import Data from "../../../../../admin/pages/add-product/components/Data";

export default {
  components: {
    FileUploader,
    // quillEditor,
    Cropper,
  },
  data() {
    return {
      title: "",
      Location: null,
      options: [
        { value: null, text: "Please select Location" },
        { value: "India", text: "India" },
        { value: "Global", text: "Global" },
      ],
      Category: null,
      Categoryoptions: [
        { value: null, text: "Please select Category" },
        { value: "Palliative", text: "Palliative" },
        { value: "Cancer", text: "Cancer" },
        { value: "Dementia", text: "Dementia" },
        { value: "Neurological Disorders", text: "Neurological Disorders" },
      ],
      link: "",
      image: null,
      coverImage: null,
      Description: "",
    };
  },
  methods: {
    handleSuccess(image) {
      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
      } else if (!image.type.includes("image")) {
        this.$swal.fire({
          title: "File Type!",
          html: "<p style='text-align:center'>Please ensure that the file Type should be Image</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      } else {
        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    async onSubmit() {
      let Regex = /^(https?:\/\/)?([a-z0-9-]+\.)+[a-z0-9-]{2,6}(\/[^\s]*)?$/i;
      if (!Regex.test(this.link.trim())) {
        this.$notify.error({
          message: "Please Enter Valid URL",
          position: "bottom-right",
        });
        return false;
      }
      //  else if (!this.coverImage) {
      //   this.$notify.error({
      //     message: "Please Select Image",
      //     position: "bottom-right",
      //   });

      //   return;
      // }
      let FormData = require("form-data");
      let data = new FormData();

      data.append("id", this.selectedMedicalForUpdate._id);
      data.append("title", this.title.trim());
      data.append("category", this.Category);
      data.append("location", this.Location);
      data.append("description", this.Description.trim());
      data.append("link", this.link.trim());
      if (this.coverImage) data.append("picture", this.coverImage);
      let loader = this.$loading();
      try {
        const newsdata = await this.$store.dispatch(
          "medicalCancer/updateMedicalCancer",
          data
        );

        if (newsdata.code == 200) {
          this.$router.push({ name: "/admin/medical_cancer" });
          this.$swal.fire({
            text: "Medical Successfully Updated",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
        loader.close();
      } catch (error) {
        if (error.response.status) {
          this.$swal.fire({
            title: "Error",

            text: error.response.data.message,
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          loader.close();
        }
      }
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
    init() {
      this.title = this.selectedMedicalForUpdate.title;
      this.Category = this.selectedMedicalForUpdate.category;
      this.Location = this.selectedMedicalForUpdate.location;
      this.link = this.selectedMedicalForUpdate.link;
      // this.image = this.selectedMedicalForUpdate.picture;
      this.image = `${this.$imageURL}/${this.selectedMedicalForUpdate.picture}`;
      // this.coverImage = this.selectedMedicalForUpdate.picture;
      this.Description = this.selectedMedicalForUpdate.description;
    },
  },
  computed: {
    ...mapState("medicalCancer", ["selectedMedicalForUpdate"]),
  },
  async mounted() {
    this.init();
  },
};
</script>
